module.exports = __webpack_public_path__ + "static/media/СЗФО_2008.6deeceff.png";